import { defineStore } from 'pinia';
// rule:state를 바로 사용할 수 없도록 _를 붙여줌
type StoreStateType = {
	_country?: 'KR' | 'USA' | 'JPN' | '';
	_selectedMenu?: string;
	_isNotificationExist?: boolean;
};
export const useHeaderStore = defineStore('header', {
	state: (): StoreStateType => {
		return {
			_country: '',
			_isNotificationExist: false,
			_selectedMenu: 'home',
		};
	},
	getters: {
		getCountry(state) {
			return state._country;
		},
		getIsNotificationExist(state) {
			return state._isNotificationExist;
		},
		getSelectedMenu(state) {
			return state._selectedMenu;
		},
	},
	actions: {
		setCountry(country: 'KR' | 'USA' | 'JPN' | '') {
			this._country = country;
		},
		setIsNotificationExist(isNotificationExist: boolean) {
			this._isNotificationExist = isNotificationExist;
		},
		setSelectedMenu(selectedMenu: string) {
			this._selectedMenu = selectedMenu;
		},
		resetHeader() {
			this.$reset();
		},
	},
	persist: true,
});
